export default {
  'title': 'Ma liste de courses',
  'nb-products-in-cart': {
    default: '%{done} / %{count} produit',
    default_plural: '%{done} / %{count} produits',
    completed: '%{done} / %{count} produit 🎉',
    completed_plural: '%{done} / %{count} produits 🎉',
  },
  'placeholder': {
    'add-product': 'Ajouter un produit',
    'edit-product': 'Modifier un produit',
  },
  'button': {
    'add-product': 'Ajouter',
    'finish': 'Terminer',
  },
  'empty-results': 'Aucun résultat pour %{term}',
  'update-search': 'Modifier la recherche',
  'dialog': {
    'not-complete': {
      title: 'Quitter la liste de course',
      description:
        'Vous n’avez pas encore ajouté tous les produits de votre liste.<br><br> Êtes-vous sûr de vouloir la quitter ?',
      cancel: 'Continuer',
      confirm: 'Quitter la liste',
    },
    'complete': {
      title: 'Liste de course ✅',
      description:
        'Votre panier se remplit. Complétez-le avec les nouveautés ou les promotions du moment.',
      cancel: 'Voir les Promotions',
      confirm: 'Voir les Nouveautés',
    },
  },
  'no-terms': {
    description: 'Aucun terme de trouvé pour cette liste de courses.',
    button: 'Modifier ma liste de courses',
  },
};
